import { apiGet, apiPost } from './client';
import type { BulkAckResponse, EventDetail, EventListResponse } from './types';

// 권위: docs/ARCH_DASHBOARD.md §6.2 [시스템 이벤트]
// REST 쿼리 파라미터는 snake_case (예: event_code, page_size) — 서버 @RequestParam 기준.

export interface EventQuery {
  severity?: string; // CSV, e.g. "FATAL,ERROR"
  source?: string;
  eventCode?: string;
  from?: string;
  to?: string;
  q?: string;
  unacked?: boolean;
  page?: number;
  pageSize?: number;
}

export function listEvents(query: EventQuery = {}): Promise<EventListResponse> {
  const params: Record<string, string | number | boolean> = {};
  if (query.severity) params.severity = query.severity;
  if (query.source) params.source = query.source;
  if (query.eventCode) params.event_code = query.eventCode;
  if (query.from) params.from = query.from;
  if (query.to) params.to = query.to;
  if (query.q) params.q = query.q;
  if (query.unacked !== undefined) params.unacked = query.unacked;
  if (query.page !== undefined) params.page = query.page;
  if (query.pageSize !== undefined) params.page_size = query.pageSize;
  return apiGet<EventListResponse>('/api/v1/events', { params });
}

export function getEventDetail(eventId: string): Promise<EventDetail> {
  return apiGet<EventDetail>(`/api/v1/events/${eventId}`);
}

export function ackEvent(eventId: string, ackBy: string, note?: string): Promise<void> {
  return apiPost<void>(`/api/v1/events/${eventId}/ack`, { ackBy, note });
}

export function ackEventsBulk(eventIds: string[], ackBy: string, note?: string): Promise<BulkAckResponse> {
  return apiPost<BulkAckResponse>('/api/v1/events/ack-bulk', { eventIds, ackBy, note });
}

// 필터 매칭 미확인 전체 ack (알림센터 "모두 읽음 처리"). severity 기본 "FATAL,ERROR".
export function ackEventsAll(severity: string, ackBy: string, note?: string): Promise<BulkAckResponse> {
  return apiPost<BulkAckResponse>('/api/v1/events/ack-all', { severity, ackBy, note });
}
